import { render, staticRenderFns } from "./AcademicYearChanger.vue?vue&type=template&id=353f1caa"
import script from "./AcademicYearChanger.vue?vue&type=script&lang=js"
export * from "./AcademicYearChanger.vue?vue&type=script&lang=js"
import style0 from "./AcademicYearChanger.vue?vue&type=style&index=0&id=353f1caa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports